module.exports = __webpack_public_path__ + "media/images/team_member/member_5-3d6dd844d73c6d235a92a9d6ffee9120.jpg";